<template>
    <div class="customer-custom-history-field py-2" :class="field_class">
        <label v-if="field.type != 'html'" class="customer-custom-history-field__label" :for="'field_' + field.id">
            {{ field.name }}
        </label>
        <div v-else>
            <h4>{{ field.name }}</h4>
        </div>
        <input :value="value" v-if="editable_type" :id="'field_' + field.id" :type="editable_type" class="form-control"
            @input="handleInput" :placeholder="placeholder">
        <textarea :value="value" v-else-if="field.type == 'textarea'" class="form-control" :id="'field_' + field.id"
            @input="handleInput" :placeholder="placeholder"></textarea>
        <div v-else-if="field.type == 'checkbox'">
            <div class="form-check form-check-inline" v-for="(val, key) in field.options.values"
                :key="`${field.slug}_${key}`">
                <input type="checkbox" :checked="value[`${field.slug}_${key}`]" class="form-check-input"
                    :id="`${field.slug}_${key}`" value="true" @input="handleInput">
                <label :for="`${field.slug}_${key}`" class="form-check-label">{{ val }}</label>
            </div>
        </div>
        <div v-else-if="field.type == 'radio'">
            <div class="form-check form-check-inline" v-for="(val, key) in field.options.values"
                :key="`${field.slug}_${key}`">
                <input type="radio" :checked="value == key" :name="field.slug" class="form-check-input"
                    :id="`${field.slug}_${key}`" :value="key" @input="handleInput">
                <label :for="`${field.slug}_${key}`" class="form-check-label">{{ val }}</label>
            </div>
        </div>
        <div v-else-if="field.type == 'select'">
            <select v-model="value" :name="field.slug" :id="'field_' + field.id" class="custom-select" @input="handleInput">
                <option>{{ placeholder }}</option>
                <option v-for="(val, key) in field.options.values" :value="key" :key="key">
                    {{ val }}
                </option>
            </select>
        </div>
        <label v-if="field.type != 'html'" class="wabident-info">{{ field.description }}</label>
    </div>
</template>

<script>
export default {
    props: ['section', 'field', 'value'],
    data() {
        return {
            content: this.value,
        };
    },
    computed: {
        placeholder() {
            if (!this.field || !this.field.options) return '';
            return this.field.options.placeholder || '';
        },
        editable_type() {
            const types = {
                "date": "date",
                "datetime": "datetime",
                "text": "text",
                "number": "number",
                "email": "email",
                "tel": "tel",
            }

            return types[this.field.type] || null;
        },
        field_class() {
            let ret = {};
            let opts = this.field.options;

            if (opts && opts.width) {
                ret['col-md-' + opts.width] = true;
            } else {
                ret['col-md-12'] = true;
            }

            return ret;
        }
    },
    methods: {
        handleInput(e) {
            switch (this.field.type) {
                case 'checkbox':
                    let val = {
                        'name': e.target.id,
                        'value': e.target.checked
                    };
                    this.$emit('input', val);
                    break;
                default:
                    this.$emit('input', e.target.value);
            }
        }
    },
    mounted() {
        if (!this.field.options) {
            console.log('Field ' + this.field.slug + ' with null options');
        }
    }
}
</script>

<style lang="scss">
.customer-custom-history-field {
    &__label {
        font-weight: 600;
    }
}
</style>